/* eslint-disable array-callback-return */

/* eslint-disable no-unused-vars */

/* eslint-disable no-nested-ternary */

/* eslint-disable no-shadow */

/* eslint-disable no-unused-expressions */

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable react/jsx-key */

/* eslint-disable react/no-unknown-property */

import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
/**
 *
 * VenueFilters
 *
 */
import classNames from 'classnames/bind'
import _ from 'lodash'
import React from 'react'

import PrimaryButton from '../Button/PrimaryButton'
import Icon from '../Icon'

const styles = theme => ({
  root: {
    display: 'inline-block',
    flexWrap: 'wrap',
    width: '100%',
    float: 'left',
  },
  formControl: {
    border: '1px solid #ccc',
    width: '100%',
    borderRadius: '5px',
    backgroundColor: theme.colors.white,
  },
  selectEmpty: {
    marginTop: theme.spacing(8),
  },
  stgSelect: {
    background: 'transparent',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& div>div': {
      width: '92%',
      padding: '7px',
      boxSizing: 'border-box',
      fontSize: '14px',
    },
  },
  memberInnerContainer: {
    border: '1px solid #ccc',
    position: 'absolute',
    top: 40,
    left: 0,
    width: 'auto',
    background: '#F3F3F3',
    padding: '0',
    zIndex: '2',
    overflowY: 'auto',
    // height: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  venueContainer: {
    height: '150px',
    overflow: 'auto',
  },
  panel: {
    '&:before': {
      display: 'none',
    },
  },
  panelSummary: {
    minHeight: 'auto !important',
    '&>div': {
      margin: '0 !important',
    },
  },
  venueLabel: {
    margin: 0,
  },
  playingSurfaceContainer: {
    padding: '0 30px 10px',
  },
  psLabel: {},
  psCheckbox: {
    height: '30px',
  },
  textAlignRight: {
    textAlign: 'right',
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  selectAll: {
    padding: '0 20px 0 0',
  },
  topContainer: {
    padding: '20px 0',
  },
  countDiv: {
    marginRight: '10px',
    background: 'green',
    borderRadius: '36%',
    padding: '2px',
    color: 'white',
  },
  topHeading: {
    padding: '10px',
    borderBottom: '1px solid #ccc',
  },
  bottomFooter: {
    padding: '20px',
    borderTop: '1px solid #ccc',
    textAlign: 'right',
  },
  crossIcon: {
    float: 'right',
  },
  middleContent: {
    padding: '3px',
  },
  noFound: {
    textAlign: 'center',
  },
  textField: {
    // height: '50px',
    border: '1px solid #ccc',
    padding: '2px 20px',
    background: '#fff',
    borderRadius: '4px',
    '& :before': {
      borderBottom: 'none',
      display: 'none',
    },
    '& :after': {
      borderBottom: 'none',
      display: 'none',
    },
    '& >div:hover': {
      borderBottom: 'none',
      ':before': {
        borderBottom: '0',
      },
    },
  },
  'cursor-pointer': {
    cursor: 'pointer',
  },
  displayInline: {
    display: 'flex',
  },
})

/* eslint-disable react/prefer-stateless-function */
class CommonFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      expanded: null,
      allData: _.cloneDeep(
        props.allData.map(item => ({
          ...item,
          isChecked: props.selectedData.indexOf(item.id) !== -1,
        }))
      ),
      selectedData: _.cloneDeep(props.selectedData),
      searchText: '',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { allData, selectedData } = nextProps
    if (!_.isEqual(this.props.allData, allData) || !_.isEqual(this.props.selectedData, selectedData)) {
      const temData = _.cloneDeep(allData)
      this.setState(
        {
          allData: temData.map(item => ({
            ...item,
            isChecked: selectedData.indexOf(item.id) !== -1,
          })),
          selectedData: _.cloneDeep(selectedData),
        },
        () => {}
      )
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('click', e => this.handleClickOutside(e))
  }

  setWrapperRef = node => {
    this.wrapperRef = node
  }

  setOutSideWrapperRef = node => {
    this.outsideWrapperRef = node
  }

  handleClickOutside = event => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      this.outsideWrapperRef &&
      !this.outsideWrapperRef.contains(event.target)
    ) {
      if (this.props.isRefreshOnClosed) {
        this.setState({
          open: false,
          allData: _.cloneDeep(
            this.props.allData.map(item => ({
              ...item,
              isChecked: this.props.selectedData.indexOf(item.id) !== -1,
            }))
          ),
          selectedData: _.cloneDeep(this.props.selectedData),
        })
      } else {
        this.setState({ open: false })
      }
    }
  }

  handleClick = () => {
    const { open } = this.state
    this.setState({ open: !open })
  }

  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  handleSingleClick = (event, key) => {
    const { allData, selectedData } = this.state
    const { roundsData } = this.props
    const tempFilteredData = [...allData]
    tempFilteredData[key].isChecked = !tempFilteredData[key].isChecked // prev case
    if (tempFilteredData[key].isChecked) {
      // push
      if (selectedData.indexOf(tempFilteredData[key].id) === -1) {
        roundsData ? selectedData.push(tempFilteredData[key].name) : selectedData.push(tempFilteredData[key].id)
      }
    } else {
      // slice
      roundsData
        ? selectedData.splice(selectedData.indexOf(tempFilteredData[key].name), 1)
        : selectedData.splice(selectedData.indexOf(tempFilteredData[key].id), 1)
    }
    this.setState({
      allData: tempFilteredData,
      selectedData,
    })
  }

  handleSelectAllClick = () => {
    const { roundsData } = this.props
    const { allData } = this.state
    const tempFilteredData = [...allData]

    const tempSelectData = roundsData ? tempFilteredData.map(item => item.name) : tempFilteredData.map(item => item.id)

    this.setState({
      allData: allData.map(item => ({
        ...item,
        isChecked: true,
      })),
      selectedData: tempSelectData,
    })
  }

  handleNoneClick = () => {
    const { roundsData } = this.props
    const { allData } = this.state
    const tempFilteredData = [...allData]

    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const tempSelectData = roundsData ? tempFilteredData.map(item => item.name) : tempFilteredData.map(item => item.id)
    this.setState({
      allData: allData.map(item => ({
        ...item,
        isChecked: false,
      })),
      selectedData: [],
    })
  }

  handleChange = () => {
    const { allData } = this.state
    const filterData = allData.filter(item => item.isChecked)
    this.props.returnData(filterData)
    this.setState({ open: false })
  }

  handleCross = () => {
    this.setState({
      open: false,
      allData: _.cloneDeep(
        this.props.allData.map(item => ({
          ...item,
          isChecked: this.props.selectedData.indexOf(item.id) !== -1,
        }))
      ),
      selectedData: _.cloneDeep(this.props.selectedData),
    })
  }

  handleSearch = searchText => {
    const res = this.props.allData.length > 0 ? this.createfilteredData(this.props.allData) : []
    const tempFilteredData = res
    const tempArr = tempFilteredData[0].value.filter(data => {
      const stringText = data.name ? `${data.name}` : `${data.name}`
      return stringText.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    })
    this.setState({
      allData: tempArr,
      searchText: searchText.toLowerCase(),
    })
  }

  createfilteredData = filterData => {
    const { selectedData } = this.state
    const dataArr = []
    filterData.map(data => {
      let isCheckedRes = false
      // biome-ignore lint/complexity/useOptionalChain: TODO
      if (data && data.name) {
        isCheckedRes = selectedData.indexOf(data.id) !== -1
        const obj = {
          name: data.name,
          id: data.id,
          isChecked: isCheckedRes,
        }
        dataArr.push(obj)
      }
    })

    const rawDataArr = [{ key: 'Venues', key_prefix: '', value: dataArr }]
    return rawDataArr
  }

  render() {
    const { classes, name, heading, search, selectedHeading } = this.props
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { expanded, open, allData, selectedData, searchText } = this.state
    let itemHeading

    if (selectedData.length > 0) {
      itemHeading = (
        <span>
          <span className={classes.countDiv}>{selectedData.length} </span> <span>Selected {selectedHeading || ''}</span>
        </span>
      )
    } else if (heading) {
      itemHeading = heading
    } else {
      itemHeading = 'None Selected'
    }

    return (
      <div autoComplete="on" className={classes.root} ref={this.setWrapperRef}>
        <FormControl className={classes.formControl}>
          <Select value="" displayEmpty readOnly className={classes.stgSelect} onClick={this.handleClick}>
            <MenuItem value="">{itemHeading}</MenuItem>
          </Select>
          {open && (
            <div ref={this.setOutSideWrapperRef}>
              <Grid
                container
                className={classes.memberInnerContainer}
                style={this.props.width ? { width: this.props.width } : null}
              >
                <Grid item xs={12} className={classes.topHeading}>
                  <span>{name || ''}</span>
                  <Icon
                    iconName="cross"
                    color="grey"
                    className={classes.crossIcon}
                    onClick={event => this.handleCross(event)}
                  />
                </Grid>
                {search ? (
                  <Grid item xs={12} className={classNames(classes.topContainer, classes.middleContent)}>
                    <TextField
                      id="search"
                      placeholder="Enter Keywords"
                      type="search"
                      className={classes.textField}
                      margin="normal"
                      value={searchText}
                      onChange={event => {
                        this.handleSearch(event.target.value)
                      }}
                    />
                  </Grid>
                ) : null}
                <Grid item xs={6} className={classNames(classes.middleContent, classes.displayInline)}>
                  {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
                  {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
                  <span classNames={classes['cursor-pointer']} onClick={event => this.handleSelectAllClick(event)}>
                    <Icon iconName="check" color="grey" />
                    Check All
                  </span>
                </Grid>
                <Grid item xs={6} className={classNames(classes.middleContent, classes.displayInline)}>
                  {/** biome-ignore lint/a11y/noStaticElementInteractions: TODO */}
                  {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
                  <span
                    onClick={event => {
                      this.handleNoneClick(event)
                    }}
                    className={classes['cursor-pointer']}
                  >
                    <Icon iconName="uncheck" color="grey" />
                    Uncheck All
                  </span>
                </Grid>

                <Grid item xs={12}>
                  <div className={classes.venueContainer}>
                    {allData.length > 0 ? (
                      allData.map((option, key) => (
                        // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                        <div className={classes.panel}>
                          <FormControlLabel
                            className={classes.venueLabel}
                            control={
                              <Checkbox
                                // checked={this.state.checkedB}
                                onClick={event => {
                                  this.handleSingleClick(event, key)
                                }}
                                checked={option.isChecked}
                                value={option.id}
                                color="secondary"
                              />
                            }
                            label={option.name}
                          />
                        </div>
                      ))
                    ) : (
                      <div className={classes.noFound}>No Data Found</div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} className={classes.bottomFooter}>
                  <PrimaryButton
                    onClick={e => {
                      this.handleCross(e)
                    }}
                  >
                    Cancel
                  </PrimaryButton>

                  <PrimaryButton onClick={() => this.handleChange()}>Done</PrimaryButton>
                </Grid>
              </Grid>
            </div>
          )}
        </FormControl>
      </div>
    )
  }
}

CommonFilter.defaultProps = {
  // onChange: () => {},
  // filterData,
  selectedData: [],
  search: false,
  isRefreshOnClosed: false,
}
export default withStyles(styles)(CommonFilter)
